import React, { Component } from "react";
import { Form } from "react-final-form";
import setFieldTouched from "final-form-set-field-touched";
import arrayMutators from "final-form-arrays";
import Page from "./Page";
import MultiPage from "./MultiPage";
import decorators from "./Decorators/decorators";
class SimpleForm extends Component {
  render() {
    const {
      multiPage,
      uiSchema,
      uiSchema_meta,
      uiSchema_nav,
      uiSchema_lookup,
      inputResolver,
      handleSave,
      handleSubmit,
      history,
      initialValues,
      formStyles,
      returningToForm,
      profiles,
      counties,
      gqlQueriesMutations,
      appId,
      formName,
      toggleModal,
      closeModal,
      formExit,
      renderFormExit,
      renderFormActions,
      reuseMetadata,
      form_ui,
      form_ui_name,
      formSubmitting,
      disableValidation,
      tablePagesErrors,
      validateOnLoad,
      pageLock,
      displayFormWarnings,
      formSaveMutation,
      formSaveMutationCallback,
    } = this.props;

    const defaultFormStyle = {
      flexBasis: "50%",
    };

    return (
      <div style={formStyles || defaultFormStyle}>
        {multiPage ? (
          <MultiPage
            history={history}
            handleSubmit={handleSubmit}
            initialValues={initialValues}
            returningToForm={returningToForm}
            inputResolver={inputResolver}
            uiSchema={uiSchema}
            uiSchema_meta={uiSchema_meta}
            uiSchema_nav={uiSchema_nav}
            uiSchema_lookup={uiSchema_lookup}
            profiles={profiles}
            counties={counties}
            gqlQueriesMutations={gqlQueriesMutations}
            toggleModal={toggleModal}
            closeModal={closeModal}
            formExit={formExit}
            renderFormExit={renderFormExit}
            renderFormActions={renderFormActions}
            reuseMetadata={reuseMetadata}
            form_ui={form_ui}
            form_ui_name={form_ui_name}
            formSubmitting={formSubmitting}
            disableValidation={disableValidation}
            tablePagesErrors={tablePagesErrors}
            validateOnLoad={validateOnLoad}
            pageLock={pageLock}
            displayFormWarnings={displayFormWarnings}
            formSaveMutation={formSaveMutation}
            formSaveMutationCallback={formSaveMutationCallback}
          />
        ) : (
          <Form
            onSubmit={handleSave}
            decorators={[...decorators]}
            initialValues={initialValues}
            mutators={{
              ...arrayMutators,
              setFieldTouched,
            }}
            render={({ form, handleSubmit, pristine, invalid, values }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <Page
                    formValues={values}
                    uiSchema={uiSchema}
                    inputResolver={inputResolver}
                    returningToForm={returningToForm}
                    pristine={pristine}
                    invalid={invalid}
                    closeModal={closeModal}
                    formApi={form}
                    profiles={profiles}
                    counties={counties}
                    appId={appId}
                    formName={formName}
                  />
                </form>
              );
            }}
          />
        )}
      </div>
    );
  }
}

export default SimpleForm;
